export const CAMPAIGN_ENTITY_TYPES = {
  FUND: 1,
  MANDATE: 2,
  RFI: 3,
  GENERAL_INTEREST: 4,
  RESEARCH: 5,
}
